import { Link } from "react-router-dom";
import { LOGO_URL } from "../lib/api";
import { Instagram, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-stone-800/60 bg-stone-950 mt-16"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="Wood by ZQ"
              className="h-14 w-14 object-contain logo-invert"
            />
            <span className="font-display font-bold tracking-[0.18em] text-stone-50 text-base">
              WOOD BY ZQ
            </span>
          </div>
          <p className="mt-6 text-stone-400 max-w-md leading-relaxed">
            One-of-one woodwork — cutting boards, ashtrays, keepsake boxes, and
            anything you can dream up. Built by hand from solid hardwood.
          </p>
        </div>

        <div>
          <p className="text-overline text-stone-500 mb-5">Site</p>
          <ul className="space-y-3">
            <li>
              <Link to="/shop" className="text-stone-300 hover:text-amber-500">
                Shop
              </Link>
            </li>
            <li>
              <Link to="/instruments" className="text-stone-300 hover:text-amber-500">
                Instruments
              </Link>
            </li>
            <li>
              <Link to="/custom" className="text-stone-300 hover:text-amber-500">
                Custom builds
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-stone-300 hover:text-amber-500">
                About
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-overline text-stone-500 mb-5">Contact</p>
          <ul className="space-y-3">
            <li>
              <a
                href="mailto:woodbyzq@gmail.com"
                className="text-stone-300 hover:text-amber-500 flex items-center gap-2"
              >
                <Mail size={16} /> woodbyzq@gmail.com
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/woodbyzq/"
                className="text-stone-300 hover:text-amber-500 flex items-center gap-2"
                rel="noreferrer"
                target="_blank"
              >
                <Instagram size={16} /> Instagram
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-stone-800/60">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-16 py-6 flex flex-col sm:flex-row justify-between items-center gap-4 text-stone-500 text-xs tracking-widest uppercase">
          <p>© {new Date().getFullYear()} Wood by ZQ. All work hand-built.</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-amber-500">
            Owner login
          </Link>
        </div>
      </div>
    </footer>
  );
}
